export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineTemp.worker.04ca90a562792bc6d1ed-engineTemp.worker.worker.js");
}
